import { render, staticRenderFns } from "./AtencionProcesos.vue?vue&type=template&id=7cc046c6"
import script from "./AtencionProcesos.vue?vue&type=script&lang=js"
export * from "./AtencionProcesos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports